import React from "react";
import { slugify } from "../../../utils/slugify";
import "./MenuSection.css";

export default function MenuSection({ section, index, onItemClick, gridView }) {
  const sectionId = slugify(section.category);

  return (
    <div
      id={sectionId}
      className="qr-menu-section fade-in"
      style={{ animationDelay: `${index * 100}ms` }}
    >
      <h3 className="qr-menu-section-title">
        {section.category}
        {section.iconUrl && (
          <img
            src={section.iconUrl}
            alt="Category Icon"
            className="section-icon-iconUrl"
            style={{ marginLeft: "4px" }}
          />
        )}
      </h3>

      <ul className={`qr-menu-items ${gridView ? "grid-view" : "list-view"}`}>
        {section.items?.map((item, idx) => (
          <li key={idx} className="qr-menu-item">
            {item.imageUrl && (
              <img
                src={item.imageUrl}
                alt={item.nameEn || item.nameHy || "Menu item image"}
                className="qr-menu-item-image"
                loading="lazy"
                onClick={() => onItemClick(item)}
              />
            )}
            {(item.imageUrl || item.info || item.nameEn || item.nameHy) && (
              <div className="qr-menu-item-text" onClick={() => onItemClick(item)}>
                <div className="qr-menu-item-line">
                  <span className="item-name-block">
                    {item.nameHy && <span className="item-name-hy">{item.nameHy}</span>}
                    {item.nameEn && <span className="item-name-en">{item.nameEn}</span>}
                  </span>
                  <span className="dots"></span>
                  <strong className="item-price">{item.price} AMD</strong>
                </div>
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}